import { render, staticRenderFns } from "./DictionariesIndex.vue?vue&type=template&id=6bee42fa&scoped=true&"
import script from "./DictionariesIndex.vue?vue&type=script&lang=js&"
export * from "./DictionariesIndex.vue?vue&type=script&lang=js&"
import style0 from "./DictionariesIndex.vue?vue&type=style&index=0&id=6bee42fa&lang=scss&scoped=true&"
import style1 from "./DictionariesIndex.vue?vue&type=style&index=1&id=6bee42fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bee42fa",
  null
  
)

export default component.exports